import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { ChatRealtimeService } from '../../../core/services/chat-realtime.service';
import { TranslatePipe } from '../../../core/i18n/translate.pipe';

@Component({
  selector: 'app-admin-chat-notifier',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './admin-chat-notifier.component.html',
  styleUrl: './admin-chat-notifier.component.scss'
})
export class AdminChatNotifierComponent {
  readonly canUseChat;
  readonly unreadCount;

  constructor(
    private readonly auth: AuthService,
    private readonly realtime: ChatRealtimeService
  ) {
    this.canUseChat = this.auth.canUseChat;
    this.unreadCount = this.realtime.unreadCount;
  }
}
